import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { makeStyles } from '@mui/styles'
import observeElement from '@/modules/_helpers/observeElement'
import { Link } from 'react-router'

const useStyles = makeStyles((theme) => ({
  container: ({ active }) => ({
    padding: '30px 60px 20px 30px',
    display: 'flex',
    borderBottom: theme.border,
    color: theme.text,
    textDecoration: 'none',
    background: active ? theme.white : 'transparent',
    '&:hover': {
      '& $headline': {
        fontWeight: theme.fontWeights.medium,
      },
    },
  }),
  headline: ({ active }) => ({
    margin: '0 0 5px 0',
    fontSize: 14,
    lineHeight: '14px',
    fontWeight: active ? 500 : 400,
    color: theme.primary,
  }),
  text: {
    fontSize: 10,
    lineHeight: '18px',
    color: theme.textLight,
  },
}))

const SubnavigationItem = (props) => {
  const {
    link,
    headline,
    text,
    refList,
    refItem,
    customThresholdForObserver,
  } = props

  const [isActive, setIsActive] = useState(false)

  const observerCallback = entries => {
    entries.forEach((entry) => setIsActive(entry.isIntersecting))
  }

  useEffect(() => {
    if (refList && Object.keys(refList).includes(link)) {
      const observer = observeElement(
        refList[link],
        observerCallback,
        ...(customThresholdForObserver && { threshold: customThresholdForObserver }
        ))

      return () => observer.disconnect()
    }
  }, [refList, link])

  useEffect(() => {
    if (refItem && !refList) {
      const observer = observeElement(
        refItem,
        observerCallback,
        ...(customThresholdForObserver && { threshold: customThresholdForObserver }
        ))
      return () => observer.disconnect()
    }
  }, [refItem, link])

  const styles = useStyles({ active: isActive })

  const { origin, pathname } = window.location || {}

  return (
    <Link replace to={`${origin}${pathname}#${link}`} className={styles.container}>
      <div>
        <p className={styles.headline}>{headline}</p>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </Link>
  )
}

export const propTypes = {
  link: PropTypes.string,
  icon: PropTypes.string,
  headline: PropTypes.string,
  text: PropTypes.string,
  customThresholdForObserver: PropTypes.arrayOf(PropTypes.number),
  refElement: PropTypes.object,
}

SubnavigationItem.propTypes = propTypes

export default SubnavigationItem
